import { withIfUser } from '@app/components/common/Routes';
import { hasPermissions } from '@app/utils';
import UnitDetail from '@app/views/ProjectUnit/Detail';
import { memo } from 'react';

export default memo(
  withIfUser(UnitDetail)({
    condition: ({ roles }) => roles.some(hasPermissions),
    redirect: true,
    redirectTo: '/unauthorized',
  })
);
